const getInitials = (name) => {
  if (!name.trim()) {
    return '';
  }

  const seed = name.trim().split(' ');
  const firstInitial = seed[0];
  const lastInitial = seed[seed.length - 1];

  let initials = firstInitial[0];
  if (firstInitial[0] !== lastInitial[0]) {
    initials += lastInitial[0];
  }
  return initials.toUpperCase();
};

export default getInitials;
